// extracted by mini-css-extract-plugin
export default {"container_external":"MenuDesktop_container_external__OPShQ","scrolled":"MenuDesktop_scrolled__SQzH4","list":"MenuDesktop_list__Vp+QK","container":"MenuDesktop_container__lrdfj"};